import { render, staticRenderFns } from "./TempPdf1.vue?vue&type=template&id=ba83eb8a&scoped=true"
import script from "./TempPdf1.vue?vue&type=script&lang=js"
export * from "./TempPdf1.vue?vue&type=script&lang=js"
import style0 from "./TempPdf1.vue?vue&type=style&index=0&id=ba83eb8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba83eb8a",
  null
  
)

export default component.exports